// import React from 'react'
import LocalConvenienceStore from '@mui/icons-material/LocalConvenienceStore';
import loadable from '@loadable/component'
// import { Loading } from "react-admin";


const MasterCustomerListComponent = {
    list: loadable(() => import("./MasterCustomerList")),
    // create: MasterItemCreate,
    icon: <LocalConvenienceStore />,
    edit: loadable(() => import("./MasterCustomerEdit")),
    options: {
        label: 'Master Customer',
        items: true
    }
};

export default MasterCustomerListComponent